import lodash from "lodash";
import moment from "moment";
import {
    createFieldDate,
    createFieldDatetime,
    createFieldInput,
    createFieldSelect,
    createFieldTreeSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { callCountry } from "../../../haz/request/haz-info/haz-info.section";

//const Address = defineAsyncComponent(() => import("../../../../../components/address/Address"));
//const CTable = defineAsyncComponent(() => import("../../../../../components/table/CTable"));
//const HazMainSubStanceList = defineAsyncComponent(() => import("./HazMainSubStanceList"));
//const CSelect = defineAsyncComponent(() => import("../../../../../components/input/template-builder/select/CSelect"));

export const callTransportByWay = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "TRANSPORT_BY_WAY", value: searchQuery });
export const callTransportObjective = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "TRANSPORT_OBJECTIVE", value: searchQuery });
export const callCustoms = ({ searchQuery, refDepartmentId, refTransportByWayKey }) => {
    if (["01", "05"].includes(refTransportByWayKey)) {
        refTransportByWayKey = ["01", "05"];
    } else {
        refTransportByWayKey = [refTransportByWayKey];
    }
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "departmentCustomses.refDepartment.id", type: "UUID", operator: "=", value: refDepartmentId },
        // { name: "departmentCustomses.refTransportByWay.key", type: "String", operator: "in", value: refTransportByWayKey }
    ];
    if (searchQuery) {
        where.push(
            { openBucket: true, name: "name", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "code", type: "String", operator: "like", value: searchQuery }
        );
    }
    return store
        .dispatch("resource/v1/master/customs/search", {
            criteria: {
                isDistinct: true,
                select: ["*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "name", type: "ASC" }]
            }
        })
        .then(page => page.data);
};
export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "main" });
export const callDepartmentImport = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/department/cacheFindAll", {
        type: "main",
        where: [
            { openBucket: true, name: "nameTh", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "fullCode", operator: "like", value: searchQuery },
            { name: "isImport", operator: "=", value: true }
        ],
        sort: [{ name: "fullCode", type: "ASC" }]
    });
export const callDepartmentExport = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/department/cacheFindAll", {
        type: "main",
        where: [
            { openBucket: true, name: "nameTh", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "fullCode", operator: "like", value: searchQuery },
            { name: "isExport", operator: "=", value: true }
        ],
        sort: [{ name: "fullCode", type: "ASC" }]
    });

export const createField = ({ props, data, key /* , isLoading */ }) => {
    const { viewOnly /* , menuContext */, suffix, importExportDateTitle, refOriginDestinationCountryTitle } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}importExportDate${suffix}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () =>
                    importExportDateTitle ||
                    `${
                        ["1", "2"].includes(model?.refOperation?.value)
                            ? i18n.global.t("views.request.informInfo.date", { text: model?.refOperation?.value })
                            : i18n.global.t("views.request.informInfo.dateFull")
                    }`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `importExportDate${suffix}`),
                            "onUpdate:value": value => lodash.set(model, `importExportDate${suffix}`, value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <div></div>
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refTransportByWay${suffix}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.refTransportByWay"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refTransportByWay${suffix}`),
                            "onUpdate:value": value => {
                                lodash.set(model, `refTransportByWay${suffix}`, value);
                                // lodash.set(model, `refPassCustoms${suffix}`, null);
                            },
                            disabled: viewOnly,
                            list: callTransportByWay,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visibleInput: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refTransportObjective${suffix}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.refTransportObjective"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refTransportObjective${suffix}`),
                            "onUpdate:value": value => lodash.set(model, `refTransportObjective${suffix}`, value),
                            disabled: viewOnly,
                            list: callTransportObjective,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}vehicleNo${suffix}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.vehicleNo"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `vehicleNo${suffix}`),
                            "onUpdate:value": value => lodash.set(model, `vehicleNo${suffix}`, value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}containerNo${suffix}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.containerNo"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `containerNo${suffix}`),
                            "onUpdate:value": value => lodash.set(model, `containerNo${suffix}`, value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}sealNo${suffix}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.sealNo"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `sealNo${suffix}`),
                            "onUpdate:value": value => lodash.set(model, `sealNo${suffix}`, value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refOriginDestinationCountry${suffix}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () =>
                    refOriginDestinationCountryTitle ||
                    `${i18n.global.t("views.request.informInfo.country", {
                        text:
                            model?.refOperation?.key === "1"
                                ? i18n.global.t("views.request.informInfo.source")
                                : model?.refOperation?.key === "2"
                                ? i18n.global.t("views.request.informInfo.desc")
                                : i18n.global.t("views.request.informInfo.countryFull")
                    })}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refOriginDestinationCountry${suffix}`),
                            "onUpdate:value": value => lodash.set(model, `refOriginDestinationCountry${suffix}`, value),
                            disabled: viewOnly,
                            list: callCountry,
                            renderLabel: ({ item }) => (
                                <span>
                                    {item.nameEnS} : {item.nameTh}
                                </span>
                            )
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            // createFieldSelect({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}refImportCheckpoint${suffix}`,
            //     colProp: () => ({ xs: 24, md: 12 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () =>
            //         !suffix && model?.refOperation?.key === "2"
            //             ? i18n.global.t(`model.inform.refImportCheckpoint2`)
            //             : i18n.global.t(`model.inform.refImportCheckpoint${suffix}`),
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             {
            //                 value: lodash.get(model, `refImportCheckpoint${suffix}`),
            //                 "onUpdate:value": value => {
            //                     lodash.set(model, `refImportCheckpoint${suffix}`, value);
            //                     lodash.set(model, `refPassCustoms${suffix}`, null);
            //                 },
            //                 disabled: viewOnly,
            //                 list: model?.refOperation?.key === "2" || suffix === "2" ? callDepartmentExport : callDepartmentImport,
            //                 renderLabel: ({ item }) => (
            //                     <div>
            //                         {item.fullCode} : {item.nameTh}
            //                     </div>
            //                 ),
            //                 filterWhere: ({ value }) => [
            //                     { name: "fullCode", operator: "like", value },
            //                     { logic: "OR", name: "nameTh", operator: "like", value }
            //                 ],
            //                 treeDefaultExpandAll: true
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         )
            // }),
            createFieldTreeSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refImportCheckpoint${suffix}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () =>
                    !suffix && model?.refOperation?.key === "2"
                        ? i18n.global.t(`model.inform.refImportCheckpoint2`)
                        : i18n.global.t(`model.inform.refImportCheckpoint${suffix}`),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refImportCheckpoint${suffix}`),
                            "onUpdate:value": value => {
                                lodash.set(model, `refImportCheckpoint${suffix}`, value);
                                lodash.set(model, `refPassCustoms${suffix}`, null);
                            },
                            disabled: viewOnly,
                            list: callDepartment,
                            optEnabled: model?.refOperation?.key === "2" || suffix === "2" ? "isExport" : "isImport",
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.fullCode} : {item.nameTh}
                                </div>
                            ),
                            filterWhere: ({ value }) => [
                                { name: "fullCode", operator: "like", value },
                                { logic: "OR", name: "nameTh", operator: "like", value }
                            ],
                            treeDefaultExpandAll: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTreeSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refExportCheckpoint${suffix}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.refExportCheckpoint"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refExportCheckpoint${suffix}`),
                            "onUpdate:value": value => lodash.set(model, `refExportCheckpoint${suffix}`, value),
                            disabled: viewOnly,
                            list: callDepartment,
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.fullCode} : {item.nameTh}
                                </div>
                            ),
                            filterWhere: ({ value }) => [
                                { name: "fullCode", operator: "like", value },
                                { logic: "OR", name: "nameTh", operator: "like", value }
                            ],
                            treeDefaultExpandAll: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refPassCustoms${suffix}`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () =>
                    !suffix && model?.refOperation?.key === "2"
                        ? i18n.global.t(`model.inform.refPassCustoms2`)
                        : i18n.global.t(`model.inform.refPassCustoms${suffix}`),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(model, `refPassCustoms${suffix}`),
                            "onUpdate:value": value => lodash.set(model, `refPassCustoms${suffix}`, value),
                            disabled:
                                viewOnly ||
                                !lodash.get(model, `refImportCheckpoint${suffix}.id`)
                                // || !lodash.get(model, `refTransportByWay${suffix}.id`)
                            ,
                            list: ({ searchQuery }) =>
                                callCustoms({
                                    searchQuery,
                                    refDepartmentId: lodash.get(model, `refImportCheckpoint${suffix}.id`),
                                    refTransportByWayKey: lodash.get(model, `refTransportByWay${suffix}.key`)
                                }),
                            renderLabel: ({ item }) => (
                                <span>
                                    {item.code} : {item.name}
                                </span>
                            )
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDatetime({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refTransferDeclaration.createDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inform.refTransferDeclarationCreateDate"),
                inputProp: ({ field }) => {
                    const value = lodash.get(model, `refTransferDeclaration.createDate`);
                    return lodash.merge(
                        {
                            value: value ? moment(value).format("YYYY-MM-DD[T]HH:mm:ssZ") : null,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            })
        ]
    });
};
